import React, { useMemo } from 'react';
import { ResultsPodium } from '../ResultsPodium/ResultsPodium';
import { Participant } from '../../types';
import { Icons } from '../../../../Components/Icons/Icons';
import { useLeaderboardParticipants } from '../../../../hooks/useLeaderboardParticipants';
import './ResultsHeader.scss';

interface ResultsHeaderProps {
  selectedEventId?: number;
}

export const ResultsHeader: React.FC<ResultsHeaderProps> = ({ selectedEventId }) => {
  const { participants } = useLeaderboardParticipants(selectedEventId);

  const podiumParticipants: Participant[] = useMemo(() => {
    const prizeByRank: Record<number, string> = { 1: 'Cruise', 2: 'iPhone', 3: 'Money' };
    const medalByRank: Record<number, React.ReactNode> = {
      1: Icons.MedalFirst,
      2: Icons.MedalSecond,
      3: Icons.MedalThird,
    };

    return (participants || []).slice(0, 3).map((p) => ({
      id: p.id,
      name: `${p.firstName} ${p.lastName}`.trim(),
      position: p.rank,
      prize: prizeByRank[p.rank] || 'Cruise',
      medalIcon: medalByRank[p.rank] || Icons.MedalFirst,
    }));
  }, [participants]);

  return (
    <div className="results-header">
      <ResultsPodium participants={podiumParticipants} />
    </div>
  );
};
